// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"84537ccd","977":"56c18aed"}[chunkId] + ".chunk.js";
};